<template>
  <div ref="qrCodeArea">
    <ul class="list-qr">
      <li v-for="(item, index) in qrArray" :key="index">
        <div class="name">{{ item.name }}</div>
        <div class="qr">
          <QRCodeStyling
            :imageOptions="{
              crossOrigin: 'anonymous',
              margin: 10,
              imageSize: 0.5,
            }"
            :size="300"
            :data="item.qrCode"
          />
        </div>
        <div class="bank">{{ item.bankAccountNumber }}</div>
        <div class="bank-name">{{ item.bankCode }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
  // import VueQrcode from 'vue-qrcode-component';
  import { ChangeQrStatus } from '@/services/customer-support/account'
  import QRCodeStyling from './qrCodeStyling.vue'

  export default {
    // props: ['qrArray'],
    components: {
      QRCodeStyling,
    },
    data() {
      return {
        // list: [{
        //   name: 'HP Shop',
        //   qrCode: '00020101021138540010A00000072701240006970407011056906886680208QRIBFTTA53037045802VN63042346',
        //   accountId: '5690688668',
        //   bankName: 'Mạc Văn Tân',
        // },
        // {
        //   name: 'HP Star',
        //   qrCode: '00020101021138540010A00000072701240006970407011056906886680208QRIBFTTA53037045802VN63042346',
        //   accountId: '5690688668',
        //   bankName: 'Mạc Văn Tân',
        // },
        // {
        //   name: 'Mạc Văn Tân',
        //   qrCode: '00020101021138580010A000000727012800069704070114190322856820100208QRIBFTTA53037045802VN8300840063047008',
        //   accountId: '19032285682010',
        //   bankName: 'Techcombank',
        // }],
        qrArray: [],
      }
    },

    created() {
      this.qrArray = this.$route.params.qrArray || []
      console.log(this.qrArray)
    },
    mounted() {
      // window.setData = (data) => {
      //   this.qrArray = data
      //   console.log(data)
      // }
      if (!this.qrArray || this.qrArray.length === 0) {
        // this.$router.push(`/customer-support/account-qr`);
      }
      this.changeStatusQr()
      this.$nextTick(async () => {
        await window.print()
        setTimeout(() => {
          this.$router.push(`/customer-support/account-qr`)
        }, 1000)
      })
    },
    methods: {
      async changeStatusQr() {
        try {
          // Giả lập gọi API để đổi trạng thái
          const ids = this.qrArray?.reduce((arr, qr) => {
            arr.push(qr.id)
            return arr
          }, [])
          const Body = {
            status: 'PRINTED',
            ids: ids,
          }
          const res = await ChangeQrStatus(Body)

          if (res.result) {
            console.log('Trạng thái QR đã được đổi thành printed')
          } else {
            console.error('Lỗi khi đổi trạng thái QR')
          }
        } catch (error) {
          console.error('Lỗi khi gọi API:', error)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  ul.list-qr {
    padding-left: 0;
    list-style: none;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    li {
      clear: both;
      display: flex;
      flex-direction: column;
      justify-content: center;

      // width: 1000px;
      // height: calc(100vh);
      // overflow: hidden;
      .name {
        width: 100%;
        font-size: 120px;
        font-weight: 600;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .qr {
        display: flex;
        justify-content: center;
        margin-top: 20px;
      }

      .bank {
        width: 100%;
        font-weight: 600;
        font-size: 90px;
        text-align: center;
        margin-top: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .bank-name {
        width: 100%;
        font-size: 80px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
</style>
